/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Город
 * @export
 * @interface TravelineCityDto
 */
export interface TravelineCityDto {
    /**
     * Идентификатор города
     * @type {string}
     * @memberof TravelineCityDto
     */
    id: string;
    /**
     * Название города
     * @type {string}
     * @memberof TravelineCityDto
     */
    name: string;
    /**
     * Идентификатор региона
     * @type {string}
     * @memberof TravelineCityDto
     */
    regionId: string;
    /**
     * Трехбуквенный идентификатор страны
     * @type {string}
     * @memberof TravelineCityDto
     */
    countryCode: string;
    /**
     * Таймзона города
     * @type {string}
     * @memberof TravelineCityDto
     */
    timeZone: string;
}

/**
 * Check if a given object implements the TravelineCityDto interface.
 */
export function instanceOfTravelineCityDto(value: object): value is TravelineCityDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    return true;
}

export function TravelineCityDtoFromJSON(json: any): TravelineCityDto {
    return TravelineCityDtoFromJSONTyped(json, false);
}

export function TravelineCityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineCityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'regionId': json['regionId'],
        'countryCode': json['countryCode'],
        'timeZone': json['timeZone'],
    };
}

  export function TravelineCityDtoToJSON(json: any): TravelineCityDto {
      return TravelineCityDtoToJSONTyped(json, false);
  }

  export function TravelineCityDtoToJSONTyped(value?: TravelineCityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'regionId': value['regionId'],
        'countryCode': value['countryCode'],
        'timeZone': value['timeZone'],
    };
}

